import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/menus/$menuId/modifiers")(
  {
    component: ModifiersLayout,
  }
);

function ModifiersLayout() {
  return <Outlet />;
}
